import React, { useEffect } from "react";
import fieldPropTypes from "./field-prop-types";
import { CHIPS_PARAMS } from "../utils/constants";
import {
  getFieldActionEventStates,
  actionEventsMap
} from "../screens/helpers/action-event-states";

const { selectSingleChip, highlightChip, toggleChip } = CHIPS_PARAMS;
const hasAction = action => action && !!Object.entries(action).length;
const shouldSelectSingleChip = (params = "") =>
  params.includes(selectSingleChip);

const handleClickWrapper = (
  e,
  action,
  name,
  { values, handleChange, handleButtonClick, updateStates },
  params,
  optionValue,
  field
) => {
  const onClickEventStates = getFieldActionEventStates(
    field,
    actionEventsMap.onClick
  );

  if (hasAction(action)) {
    e.stopPropagation();
    if (action?.preNavigation === highlightChip) {
      if (shouldSelectSingleChip(params)) {
        handleChange({ [name]: optionValue });
        if (params.includes(toggleChip) && optionValue === values[name]) {
          handleChange({ [name]: "" });
        }
      }
    } else {
      handleButtonClick(name, null, action);
    }
  }
  if (onClickEventStates) {
    updateStates(onClickEventStates, false);
  }
};

const Chips = ({
  field: {
    name,
    data: { options },
    params
  },
  field,
  appData,
  components: { Chip }
}) => {
  useEffect(() => {
    options.forEach(({ isSelected, optionValue }) => {
      if (isSelected) {
        appData.handleChange({ [name]: optionValue });
      }
    });
  }, []);

  const chipstList = options.map(
    ({ action, dismiss_action, optionValue, title }) => (
      <Chip
        label={title}
        key={title}
        onLabelClick={e =>
          handleClickWrapper(
            e,
            action,
            name,
            appData,
            params,
            optionValue,
            field
          )
        }
        onDismissClick={e =>
          handleClickWrapper(e, dismiss_action, name, appData)
        }
        dismissable={hasAction(dismiss_action)}
        isSelected={
          shouldSelectSingleChip(params)
            ? optionValue === appData?.values[name]
            : false
        }
      />
    )
  );
  return <>{chipstList}</>;
};

Chips.propTypes = fieldPropTypes;

export default Chips;
